module.exports = __webpack_public_path__ + "resources/img/img_intermax_3.de39cd8ad313a46646a480ce2d9c65a9.png";